import { Box } from '@mui/material';

import JugadoresHeaderSection from '../information/JugadoresHeaderSection';
import JugadoresTabsSection from '../information/Tabs/JugadoresTabsSection';
import JugadoresConvocatoriaSeleccion from '../JugadoresConvocatoriaSeleccion';
import PlayersSeasonSelector from './PlayersSeasonSelector';
import PlayersDaysPoints from './PlayersDaysPoints';
import PlayersGraphicPoints from './PlayersGraphicPoints';
import PlayersTierPoints from './PlayersTierPoints';
import JugadoresGeneralStatus from '../JugadoresGeneralStatus';
import Placement2Component from '@/components/ads-components/placements/placement2';
import Placement6Component from '@/components/ads-components/placements/placement6';

const JugadoresPoints = ({ player, slug }) => {
    return (
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
            <JugadoresHeaderSection player={player} />
            <JugadoresTabsSection slug={slug} activeTab={1} />
            <JugadoresGeneralStatus player={player} />
            <JugadoresConvocatoriaSeleccion player={player} />
            <Placement2Component />
            <PlayersSeasonSelector player={player} slug={slug} />
            <PlayersTierPoints player={player} />
            <PlayersGraphicPoints player={player} />
            <Placement6Component />
            <PlayersDaysPoints player={player} />
        </Box>
    );
};

export default JugadoresPoints;
